export default __webpack_public_path__ + "static/media/left_blur800.bfcfef6b.png";